import { render, staticRenderFns } from "./f-footer.vue?vue&type=template&id=03985b61&scoped=true&"
import script from "./f-footer.vue?vue&type=script&lang=js&"
export * from "./f-footer.vue?vue&type=script&lang=js&"
import style0 from "./f-footer.vue?vue&type=style&index=0&id=03985b61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03985b61",
  null
  
)

export default component.exports